import React from 'react'
import { tableBatchData } from '../@signals'
import {AppReportSearchesModal} from "@components";


export default function GlobalBatchesSearchesModal() {

    return <AppReportSearchesModal data={tableBatchData.value} />
}